<div class="wrapper">
  <app-multi-labor-equipment-details
    [initialEntry]="data?.equipmentDetails || null"
    entityType="equipment"
  />
  <app-actions-section
    [disableAddMenu]="true"
    class="actions-section w-[455px]"
  />
</div>
